import React, {useEffect, useState} from 'react';

import {
  Balance,
  BalanceImage,
  BalanceInfo,
  Container,
  Content,
  ContentTitles,
  DesativatedListButtonContainer,
  Footer,
  IndicationActions,
  IndicationButton,
  IndicationButtonText,
  IndicationColumn,
  IndicationCount,
  IndicationDescription,
  IndicationFooter,
  IndicationIcon,
  IndicationInfos,
  IndicationItem,
  IndicationName,
  LinkButtonContainer,
  SwitchButton,
  SwitchContainer,
} from './styles';
import {Header} from '../../../components/Interface/Headers/Header';
import {
  StackActions,
  useIsFocused,
  useNavigation,
} from '@react-navigation/native';
import {Titles} from '../../../components/Interface/Typographies/Titles';
import {api} from '../../../services/api';
import {FlatList} from 'react-native-gesture-handler';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';

import {Loading} from '../../../components/Interface/Loadings/Loading';
import {NotFound} from '../../../components/Interface/Search/NotFound';
import {Alert, Linking} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {Button} from '../../../components/Interface/Forms/Buttons/Button';

import {LinkButton} from '../../../components/Interface/Forms/Buttons/LinkButton';
import {Icon} from '../../../components/Interface/Typographies/Icon';
import { useAuth } from '../../../context/auth';

interface ReferAndWinUsers {
  qtde_indicados: number;
  lista_indicados: any[];
}

interface Limites {
  indicadosAtivos: number;
  limiteIndicacoes: number;
  litrosAbastecidos: number;
  proximoLimite: number;
  diferencaLitros: number;
}

const MESSAGE = (
  nome: string,
) => `Oi, ${nome}! Tudo bem?
Te indiquei no Baratão Combustíveis porque é onde eu economizo de verdade. 

Quando você abastece pelo app, eu ganho dinheiro e você aproveita os menores preços do Brasil.
Pra facilitar, use o cupom VOLTESEMPRE e ganhe R$ 0,10 a mais de desconto por litro. 

Dá uma olhada no app e confere os postos perto de você. Vale muito a pena! 😉`;

export function ReferAndWinUsers() {
  const navigation = useNavigation();

  const isFocused = useIsFocused();

  const {isLogged} = useAuth();

  useEffect(() => {
    if(!isLogged){
      navigation.navigate('Home');
    }
  }, [isLogged]);


  const [data, setData] = useState<ReferAndWinUsers>({} as ReferAndWinUsers);
  const [limits, setLimits] = useState<Limites>({} as Limites);
  const [isLoading, setIsLoading] = useState(false);

  const popAction = StackActions.pop(2);

  async function fetchUsers() {
    setIsLoading(true);
    await api
      .post('/indiqueGanhe')
      .then(response => {
        setData(response.data);
      })
      .catch(() => {
        navigation.navigate('ConfirmationScreen', {
          buttonAction: () => navigation.dispatch(popAction),
          buttonText: 'Voltar para tela inicial',
          type: 'error',
          closeIconAction: () => navigation.dispatch(popAction),
          title: 'Ocorreu um problema',
          text: 'Não foi possível listar os seus indicados. Tente novamente mais tarde!',
        });
      })
      .finally(() => {
        fetchLimits();
      });
  }

  async function fetchLimits() {
    await api
      .get('/limiteIndicacoes')
      .then(response => {
        setLimits(response.data);
      })
      .catch(() => {
        navigation.navigate('ConfirmationScreen', {
          buttonAction: () => navigation.dispatch(popAction),
          buttonText: 'Voltar para tela inicial',
          type: 'error',
          closeIconAction: () => navigation.dispatch(popAction),
          title: 'Ocorreu um problema',
          text: 'Não foi possível listar os seus indicados. Tente novamente mais tarde!',
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    fetchUsers();
  }, [isFocused]);

  function formataNome(nome: string) {
    var partesDoNome = nome.split(' ');
    var primeiroNome = partesDoNome[0];

    if (partesDoNome.length >= 2) {
      var ultimoNome = partesDoNome[1];

      if (ultimoNome.length === 2) {
        return primeiroNome + ' ' + ultimoNome + partesDoNome[2];
      }

      return primeiroNome + ' ' + ultimoNome;
    } else {
      return nome;
    }
  }

  function pegaPrimeiroNome(nome: string) {
    var partesDoNome = nome.split(' ');
    var primeiroNome = partesDoNome[0];

    if (partesDoNome.length >= 2) {
      return primeiroNome;
    } else {
      return nome;
    }
  }

  function handleCutucar(telefone: string, nome: string) {
    Linking.openURL(
      `https://api.whatsapp.com/send?phone=${telefone.replace(
        '+',
        '',
      )}&text=${MESSAGE(nome)}`,
    );
  }

  function toggleSwitch(status: string, id: string) {
    if (status === 'inativo') {
      reativarIndicado(id);
    } else {
      desativarIndicado(id);
    }
  }

  async function reativarIndicado(id: string) {
    try {
      await api
        .post('/reativarIndicado', {
          indicado_id: id,
        })
        .then(() => {
          fetchUsers();
        });
    } catch ({response}: any) {
      if (response.data) {
        Alert.alert(
          'Ocorreu um problema',
          response.data.msg,
          [
            {
              text: 'Ok',
              isPreferred: true,
              onPress: () => fetchUsers(),
            },
          ],
          {
            onDismiss: () => fetchUsers(),
          },
        );
      } else {
        Alert.alert(
          'Ocorreu um problema',
          'Não foi possível ativar o indicado.',
          [
            {
              text: 'Ok',
              isPreferred: true,
              onPress: () => fetchUsers(),
            },
          ],
          {
            onDismiss: () => fetchUsers(),
          },
        );
      }
    }
  }

  async function desativarIndicado(id: string) {
    try {
      await api
        .post('/inativarIndicado', {
          indicado_id: id,
        })
        .then(() => {
          fetchUsers();
        });
    } catch ({response}: any) {
      if (response.data) {
        Alert.alert(
          'Ocorreu um problema',
          response.data.msg,
          [
            {
              text: 'Ok',
              isPreferred: true,
              onPress: () => fetchUsers(),
            },
          ],
          {
            onDismiss: () => fetchUsers(),
          },
        );
      } else {
        Alert.alert(
          'Ocorreu um problema',
          'Não foi possível desativar o indicado.',
          [
            {
              text: 'Ok',
              isPreferred: true,
              onPress: () => fetchUsers(),
            },
          ],
          {
            onDismiss: () => fetchUsers(),
          },
        );
      }
    }
  }

  const indicacoesTexto =
    limits.indicadosAtivos > 1 ? ' indicações! ' : ' indicação! ';

  return isLoading ? (
    <Loading />
  ) : (
    <Container>
      <Header icon="chevron-left" />
      <Content>
        <ContentTitles>
          <Titles
            title="Ganhe muito com indicações!"
            subtitle={`${
              limits.indicadosAtivos > 0
                ? 'Você já tem ' +
                  limits.indicadosAtivos +
                  indicacoesTexto +
                  'O Baratão oferece o único programa recorrente Indique e Ganhe do Brasil para abastecimentos, gás de cozinha e serviços de oficina mecânica.'
                : 'O Baratão oferece o único programa recorrente Indique e Ganhe do Brasil para abastecimentos, gás de cozinha e serviços de oficina mecânica.'
            }`}
          />
          <LinkButtonContainer>
            <LinkButton
              action={() => navigation.navigate('ReferAndWinUsersInfo')}
              enabled
              text="Quero mais!"
            />
          </LinkButtonContainer>
        </ContentTitles>

        {!!limits.limiteIndicacoes && (
          <DesativatedListButtonContainer>
            <IndicationCount>
              {limits.indicadosAtivos} de {limits.limiteIndicacoes}
            </IndicationCount>
            {data.lista_indicados.filter(item => item[5] === 'inativo').length >
              0 && (
              <LinkButton
                text={
                  'Indicados inativos (' +
                  data.lista_indicados.filter(item => item[5] === 'inativo')
                    .length +
                  ')'
                }
                enabled
                action={() =>
                  navigation.navigate('ReferAndWinUsersDesactivated', {data})
                }
              />
            )}
          </DesativatedListButtonContainer>
        )}

        {data.lista_indicados &&
        data.lista_indicados.filter(item => item[5] !== 'inativo').length >
          0 ? (
          <FlatList
            data={data.lista_indicados.filter(item => item[5] !== 'inativo')}
            contentContainerStyle={{paddingBottom: RFValue(20)}}
            keyExtractor={item => item}
            renderItem={({item}) => (
              <IndicationItem>
                <IndicationColumn>
                  <Icon name="user" />
                  <IndicationInfos>
                    <IndicationName>{formataNome(item[0])}</IndicationName>
                    <IndicationDescription>
                      {item[5] === 'inativo' ? 'Inativo' : item[5]}
                    </IndicationDescription>
                    <IndicationFooter>
                      <BalanceInfo>
                        <BalanceImage
                          source={require('../../../assets/images/icons/baratinha.webp')}
                        />
                        <Balance>{item[2]} btz</Balance>
                      </BalanceInfo>
                    </IndicationFooter>
                  </IndicationInfos>
                </IndicationColumn>

                <IndicationActions>
                  {item[5] !== 'inativo' && (
                    <IndicationButton
                      activeOpacity={0.7}
                      onPress={() =>
                        handleCutucar(item[3], pegaPrimeiroNome(item[0]))
                      }>
                      <IndicationIcon name="hand-pointing-right" />
                      <IndicationButtonText>Cutucar</IndicationButtonText>
                    </IndicationButton>
                  )}
                  <SwitchContainer>
                    <SwitchButton
                      value={item[5] !== 'inativo'}
                      onValueChange={() => toggleSwitch(item[5], item[4].$oid)}
                    />
                  </SwitchContainer>
                </IndicationActions>
              </IndicationItem>
            )}
          />
        ) : (
          <NotFound
            style={{marginTop: -RFPercentage(2)}}
            title="Oops... Você ainda não indicou o Baratão"
            text="Indique aos seus amigos e ganhe baratinhaZ!"
          />
        )}
      </Content>
      <Footer>
        <SafeAreaView>
          <Button
            title="Quero indicar"
            outline
            enabled
            onPress={() => navigation.navigate('ReferAndWin')}
          />
        </SafeAreaView>
      </Footer>
    </Container>
  );
}
